import React, { memo } from 'react'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { useTranslation, Trans } from 'react-i18next'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'

import generalStyles from '../../styles'
import styles from './styles'
import { combineStyles } from 'utils'
import cp2022Landing from 'assets/images/cp_2022.png'

const combinedStyles: any = combineStyles(generalStyles, styles)
const useStyles = makeStyles(combinedStyles)

const RegisterForm: React.FunctionComponent<any> = () => {
	const { i18n } = useTranslation()
	const t = i18n.getFixedT('ro')
	const theme: Theme = useTheme()
	const classes = useStyles()
	return (
		<Paper classes={{ root: classes.paper }}>
			<Grid container>
				<Grid item xs={12}>
					<div className={classes.headerTitle}>
						<div>
							{
								'Inregistreaza-te la Chill Pack 2022 editia de toamna'
							}
						</div>
					</div>
					<img
						alt="company_team"
						className={classes.image}
						src={cp2022Landing}
					/>
				</Grid>
			</Grid>
		</Paper>
	)
}

export default memo(RegisterForm)
